export const DISABLE_SCROLL = 'DISABLE_SCROLL'
export const SET_SCROLL = 'SET_SCROLL'
